import { t } from 'i18next';
import * as Alert from '../../components/Alert/Alert';
import { getState, redux } from '../../reduxService';
/* import { IProjectResultResponse } from '../MacRO1/api/IApiResponse';
import { roundToTwo } from '../MacRO1/components/InputForm/AnchorBar/utils';
import { IProjectMacro1 } from '../MacRO1/store/project/projectSlice';
import { ISlopedGabionResults, ISteppedGabionResults, IVerticalDropsResults } from '../Macro2/api/IApiResponse';
import { IChannelGeometryVerticalDropForm } from '../Macro2/components/InputForm/ChannelGeometry/IChannelGeometry';
import { IRockSlopeSlopedWeirForm } from '../Macro2/components/InputForm/RockSlope/IRockSlope';
import { IStillingBasinVerticalDropForm } from '../Macro2/components/InputForm/StillingBasin/IStillingBasin';
import { IWeirGeometrySlopedWeirForm, IWeirGeometrySteppedWeirForm, IWeirGeometryVerticalDropForm } from '../Macro2/components/InputForm/WeirGeometry/IWeirGeometry';
import { IWingsGeometrySlopedWeirForm, IWingsGeometrySteppedWeirForm, IWingsGeometryVerticalDropForm } from '../Macro2/components/InputForm/WingsGeometry/IWingsGeometry';
import { EVerticalDropsTypes } from '../Macro2/enum/general';
import { IProjectMacro2 } from '../Macro2/store/project/projectSlice';
import { getActionByProjectType } from '../actionMap'; */
import { IMacro2TemplateRequest, Info } from '../api/IApiRequest';
import { IProjectMacro1Response, IProjectMacro2Response } from '../api/IApiResponse';
import * as BeMaccaferriStoreHelper from '../api/store/BeMaccaferriStoreHelper';
import { EProjectType } from '../enum/project';
import { IProjectInfoForm } from '../pages/ProjectInfo/IProjectInfo';
import { getProjectInfo } from '../store';
import { setProjectInfo } from '../store/projectInfo/projectInfoSlice';
import { getActionByProjectType } from '../actionMap';
import { IProjectMacro2 } from '../Macro2/store/project/projectslice';
import { IProjectMacro1 } from '../Macro1/store/project/projectslice';

export const saveFile = (filename: string, fileContent: string) => {
    let bb = new Blob([fileContent], { type: 'text/plain' });
    let a = document.createElement('a');
    a.download = filename + '.mcr';
    a.href = window.URL.createObjectURL(bb);
    a.click();
};

export const removeItem = <T extends any>(arr: Array<T>, value: T): Array<T> => {
    const index = arr.indexOf(value);
    if (index > -1) {
        arr.splice(index, 1);
    }
    return arr;
};

export const isLocalEnv = () => (process.env.REACT_APP_ENVIRONMENT as string) === 'local';

export const isDevelopmentEnv = () => (process.env.REACT_APP_ENVIRONMENT as string) === 'dev';

export const isProductionEnv = () => (process.env.REACT_APP_ENVIRONMENT as string) === 'prod';

export const roundToFour = (num: number): number => {
    return parseFloat(num.toFixed(4));
};

export const saveProject = async (pInfo: IProjectInfoForm, hideAlert?: boolean): Promise<IProjectMacro1Response | IProjectMacro2Response | undefined> => {
    let responseProject: any;
    const { setProject } = getActionByProjectType(pInfo.projectType);
    const state = getState();
    /* const project = pInfo.type === EProjectType.Macro1 ? state.Macro1.project.data : state.Macro2.project.data; */
    const project = state.Macro2.project.data;
    if (!!pInfo.projectId) {
        let hasNewName = pInfo.projectName.toLowerCase() !== getProjectInfo().data?.projectName.toLowerCase();
        if (pInfo.projectType === EProjectType.Macro1) {
            responseProject =/*  !hasNewName
                ? (await BeMaccaferriStoreHelper.updateProjectAsync(project as IProjectMacro2, pInfo)).data
                : */ (await BeMaccaferriStoreHelper.addProjectAsync(pInfo)).data;
            redux.dispatch(
                setProject({
                   /*  geometry: responseProject.sectors, */
                    rockSlope: responseProject.RockSlope,
                }),
            );
        } else {
            responseProject = /* !hasNewName
                ? (await BeMaccaferriStoreHelper.updateProjectAsync(project as IProjectMacro2, pInfo)).data
                : */ (await BeMaccaferriStoreHelper.addProjectAsync(pInfo)).data;
            redux.dispatch(setProject(getProjectResponseForRedux(responseProject) as any));
        }
    } else {
       /*  if (pInfo.type === EProjectType.Macro1) {
            responseProject = (await BeMaccaferriStoreHelper.addProjectAsync(project as IProjectMacro1, pInfo)).data;
            redux.dispatch(
                setProject({
                    RockSlope: responseProject.RockSlope as any,
                }),
            );
        } else { */
            responseProject = (await BeMaccaferriStoreHelper.addProjectAsync(pInfo)).data;
            redux.dispatch(setProject(getProjectResponseForRedux(responseProject) as any));
      /*   } */
        redux.dispatch(setProjectInfo({ ...pInfo, projectId: responseProject.id }));
    }
    if (!!responseProject) {
        if (!hideAlert) Alert.success(t('header_projects_saved'));
        return responseProject;
    }
};

/* export const projectMacro2ToTemplate = (project: IProjectMacro2, infos: Info[]) => {
    let payload: IMacro2TemplateRequest = {
        infos: infos,
        soilData: project.soilData,
        RockSlope: project.RockSlope!,
    };

    return payload;
}; */

export const getProjectResponseForRedux = (resProject: IProjectMacro2Response): IProjectMacro2 => {
    let project: IProjectMacro2 = {
        rockSlope: resProject.RockSlope,
    };
    return project;
};

/* export const getVerticalDropsType = (stillingBasin: IStillingBasinVerticalDropForm | undefined): EVerticalDropsTypes => {
    if (!stillingBasin) return EVerticalDropsTypes.NotSet;
    if (!stillingBasin.isCounterweir) return EVerticalDropsTypes.UnlinedVerticalDrop;
    if (stillingBasin.isCounterweir && !stillingBasin.isStillingBasin) return EVerticalDropsTypes.UnlinedPoolAndCountweir;
    if (stillingBasin.isCounterweir && stillingBasin.isStillingBasin && stillingBasin.stillingBasinElevation === 0) return EVerticalDropsTypes.LinedPoolAndCountweirWithoutScoutDepth;
    if (stillingBasin.isCounterweir && stillingBasin.isStillingBasin && stillingBasin.stillingBasinElevation! < 0) return EVerticalDropsTypes.LinedPoolAndCountweirWithNegativeScoutDepth;
    else return EVerticalDropsTypes.NotSet;
}; */

/* export const getErrorBreadcrumb = (): IErrorBreadcrumb => {
    let errorMessage = '';
    let type = EErrorBreadcrumb.None;
    let results, project;
    let projectInfo = getState().projectInfo.data;
    if (projectInfo?.type == EProjectType.Macro1) {
        results = getState().Macro1.results.data
        project= getState().Macro1.project.data
    } else {
        results = getState().Macro2.results.data
        project= getState().Macro2.project.data
    }
    if (!!results) {
        let errors = '';
        let isThereShareStressError_Macro1 = (results as IProjectResultResponse)?.materialsResult?.some(x => x.isDangerousShearStress);
        let isThereVelocityUnderLiningError_Macro1 = (results as IProjectResultResponse)?.materialsResult?.some(x => x.isDangerousVelocityUnderLining);
        let materialError = isThereShareStressError_Macro1 || isThereVelocityUnderLiningError_Macro1;

        let isThereShareStressError_Macro2_Stepped =
            (project as IProjectMacro2)?.stillingBasin?.material.physicalData![0].allowShearStress! < (results as ISteppedGabionResults)?.basinDesign?.shearStress!;
        let isThereShareStressError_Macro2_Vertical =
            (results as IVerticalDropsResults)?.hydraulicResult?.shearStressInTheBasin > (project as IProjectMacro2).stillingBasin?.material.physicalData![0].allowShearStress!;
        let isThereShareStressError_Macro2 = isThereShareStressError_Macro2_Vertical || isThereShareStressError_Macro2_Stepped;

        let isThereVelocityUnderLiningError_Macro2_Sloped =
            (project?.RockSlope as IRockSlopeSlopedWeirForm)?.soilAdmissibleVelocity < (results as ISlopedGabionResults)?.basinDesign?.residualVelocityUnderGeotextile;
        let isThereVelocityUnderLiningError_Macro2 = isThereVelocityUnderLiningError_Macro2_Sloped;

        let isThereStability_Macro2_Vertical = (results as IVerticalDropsResults)?.staticResult?.stabilityChecksOutput?.isStabilityError;
        let isThereStaticError = isThereStability_Macro2_Vertical;

        let isThereStillingBasinWidthError_Macro2_Vertical = (project as IProjectMacro2).stillingBasin?.poolLength! < (results as IVerticalDropsResults)?.hydraulicResult?.minimumBasinLengthUsace1990;
        let isThereStillingBasinWidthError_Macro2_Stepped = (project as IProjectMacro2)?.stillingBasin?.poolLength! < (results as ISteppedGabionResults)?.basinDesign?.minLengthOfTheStillingPool!;
        let isThereStillingBasinWidthError_Macro2_Sloped = (project as IProjectMacro2)?.stillingBasin?.poolLength! < (results as ISlopedGabionResults)?.basinDesign?.jumpLength!;
        let isThereStillingBasinWidthError_Macro2 = isThereStillingBasinWidthError_Macro2_Vertical || isThereStillingBasinWidthError_Macro2_Stepped || isThereStillingBasinWidthError_Macro2_Sloped;

        let isThereCounterweirElevationError_Macro2_Stepped =
            (project as IProjectMacro2)?.stillingBasin?.counterweirElevation! < (results as ISteppedGabionResults)?.basinDesign?.minCounterweirHeight!;
        let isThereCounterweirElevationError_Macro2_Sloped = (project as IProjectMacro2)?.stillingBasin?.counterweirElevation! < (results as ISlopedGabionResults)?.basinDesign?.minCounterweirHeight!;
        let isThereCounterweirElevationError_Macro2 = isThereCounterweirElevationError_Macro2_Stepped || isThereCounterweirElevationError_Macro2_Sloped;

        let isThereBasinElevation_Macro2_Vertical_Hydraulic =
            getVerticalDropsType((project as IProjectMacro2)?.stillingBasin!) === EVerticalDropsTypes.LinedPoolAndCountweirWithNegativeScoutDepth &&
            (results as IVerticalDropsResults)?.hydraulicResult?.minimumBasinElevation! > Math.abs((project as IProjectMacro2)?.stillingBasin?.stillingBasinElevation!);
        let isThereTypeOfFlowError_Marca2_Stepped_Hydraulic = (results as ISteppedGabionResults)?.hydraulicUpstream?.typeOfFlow === 'Transition flow';
        let isThereCounterweirElevationError_Macro2_Vertical =
            getVerticalDropsType((project as IProjectMacro2)?.stillingBasin!) !== EVerticalDropsTypes.LinedPoolAndCountweirWithNegativeScoutDepth &&
            (results as IVerticalDropsResults)?.hydraulicResult?.minimumCounterweirElevation > (project as IProjectMacro2)?.stillingBasin?.counterweirElevation!;
        let isThereHydraulicError = isThereBasinElevation_Macro2_Vertical_Hydraulic || isThereTypeOfFlowError_Marca2_Stepped_Hydraulic || isThereCounterweirElevationError_Macro2_Vertical;

        let isThereScourDepthError_Macro2_Vertical =
            Math.abs((results as IVerticalDropsResults)?.hydraulicResult?.scourDepth) > ((project as IProjectMacro2).weirGeometry as IWeirGeometryVerticalDropForm)?.foundation;
        let isThereScourDepthError_Macro2 = isThereScourDepthError_Macro2_Vertical;

        let isThereBasinError =
            isThereVelocityUnderLiningError_Macro2 ||
            isThereShareStressError_Macro2 ||
            isThereStillingBasinWidthError_Macro2 ||
            isThereCounterweirElevationError_Macro2 ||
            isThereScourDepthError_Macro2;

        if (materialError) {
            if (isThereShareStressError_Macro1) {
                errors = handleAddErrorType(errors, t('share_stress'));
            }
            if (isThereVelocityUnderLiningError_Macro1) {
                errors = handleAddErrorType(errors, t('velocity_under_lining'));
            }
            type = EErrorBreadcrumb.Macro1_Material;
        } else {
            if (isThereBasinError) {
                if (isThereVelocityUnderLiningError_Macro2) {
                    errors = handleAddErrorType(errors, t('velocity_under_lining'));
                }
                if (isThereShareStressError_Macro2) {
                    errors = handleAddErrorType(errors, t('share_stress'));
                }
                if (isThereStillingBasinWidthError_Macro2) {
                    errors = handleAddErrorType(errors, t('stilling_basin'));
                }
                if (isThereCounterweirElevationError_Macro2) {
                    errors = handleAddErrorType(errors, t('counterweir_elevation'));
                }
                if (isThereScourDepthError_Macro2) {
                    errors = handleAddErrorType(errors, t('scour_depth'));
                }
                type += EErrorBreadcrumb.Macro2_Basin;
            }
            if (isThereHydraulicError) {
                if (isThereBasinElevation_Macro2_Vertical_Hydraulic) {
                    errors = handleAddErrorType(errors, t('stilling_basin'));
                }
                if (isThereCounterweirElevationError_Macro2_Vertical) {
                    errors = handleAddErrorType(errors, t('counterweir_elevation'));
                }
                if (isThereTypeOfFlowError_Marca2_Stepped_Hydraulic) {
                    errors = handleAddErrorType(errors, t('transition_flow'));
                }
                type += EErrorBreadcrumb.Macro2_Hydraulic;
            }
            if (isThereStaticError) {
                if (isThereStability_Macro2_Vertical) {
                    errors = handleAddErrorType(errors, t('stability'));
                }
                type += EErrorBreadcrumb.Macro2_Static;
            }
        }

        errorMessage = t('warning_dynamin', { value: errors }).replace(',', '');
    }
    return {
        errorMessage,
        type,
    };
}; */

const handleAddErrorType = (errorMessage: string, errorType: string): string => {
    if (!errorMessage.includes(errorType)) {
        errorMessage = errorMessage.concat(', ', errorType);
    }
    return errorMessage;
};

export enum EErrorBreadcrumb {
    None,
    Macro1_Material,
    Macro2_Hydraulic,
    Macro2_Static = 4,
    Macro2_Basin = 8,
}

interface IErrorBreadcrumb {
    errorMessage: string;
    type: EErrorBreadcrumb;
}

export const addIdToFile = (filename: string) => {
    const id = Math.random().toString(36).substring(2, 10);

    const filenameParts = filename.split('.');
    const extension = filenameParts.length > 1 ? filenameParts.pop() : '';

    const newFilename = `${filenameParts.join('.')}_${id}.${extension}`;

    return newFilename;
};

export const roundToTwo = (num: number | undefined): number => {
    if (!num) return 0;
    return parseFloat(num.toFixed(2));
};

export const roundNumbers = (obj: any) => {
    const roundNumber = (value: any) => {
        if (typeof value === 'number') {
            return Math.round(value * 100) / 100;
        } else {
            return value;
        }
    };
    const roundObject = (obj: any) => {
        let _obj = JSON.parse(JSON.stringify(obj));
        for (let key in _obj) {
            if (_obj.hasOwnProperty(key)) {
                if (typeof _obj[key] === 'object') {
                    _obj[key] = roundObject(_obj[key]);
                } else {
                    _obj[key] = key.toLowerCase() === 'id' ? _obj[key] : roundNumber(_obj[key]);
                }
            }
        }
        return _obj;
    };
    return obj ? roundObject(obj) : undefined;
};
